import { mediaData } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            人气推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选热门漫画，每一部都值得加入书架
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-50 rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2 flex gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-800 text-[10px] font-medium whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-[10px] text-background-50/90 font-medium">
                    {item.status}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-medium text-sm text-foreground-900 mb-1 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1.5 truncate">
                  {item.updateInfo}
                </p>
                <div className="flex items-center gap-1 text-xs">
                  <i className="ri-star-fill text-accent-500"></i>
                  <span className="text-foreground-700 font-medium">{item.rating}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}